import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_a_climate_adaptation_action_plan'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_a_climate_adaptation_action_plan',
  name: 'Does the facility have a climate adaptation action plan?',
  description:
    'A climate adaptation action plan refers to specific safeguards against climate related hazards (e.g., floods, droughts, extreme cold and heatwaves) developed by the facility. Safeguards can include, but are not limited to, using climate resilient construction materials, water treatment technologies, using green and renewable energy based products, waste management, reducing indoor temperatures naturally (with rooftop retrofits such as green roof, rooftop shading, etc.), training for all workers on climate related hazards and the climate adaptation action plan, and established disaster evacuation plan and trainings.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-20',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25370,
  sectionId: '2.2.6.5',
  impactArea: 'Structures and Processes',
  impactAreaId: 'STRUCTURES_AND_PROCESSES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
